import * as Rollbar from 'rollbar';
import { InjectionToken } from '@angular/core';

import { environment } from '../../environments/environment';
import { versions } from '../../environments/versions';

const rollbarConfig = {
    accessToken: environment.rollbar.accessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
        environment: environment.environment,
        client: {
            javascript: {
                // The version number cannot contain any whitespace or it will break
                code_version: versions.revision.trim(),
                source_map_enabled: true,
                guess_uncaught_frames: true
            }
        }
    }
};


/*
const rollbarConfig = {
	accessToken: 'd83fcdee10944540bf2cfb43778b94a3',
	captureUncaught: true,
	captureUnhandledRejections: true,
};
*/

export const RollbarService = new InjectionToken<Rollbar>('rollbar');
  
export function rollbarFactory() {
	  return new Rollbar(rollbarConfig);
}